<template>
  <div id="appload">
    <!-- <div class="head">
        <img src="../../assets/image/appDownLoad/mob/banner3@2x.png" class="headimg"/>
    </div> -->
    <div class="swiperContentSecond">
      <swiper :options="SwiperOption" id="teshuWhite">
        <!-- 第一个轮播图 -->
       <swiper-slide class="videoItem swiperslide">
          <div class="banner1">
            <img
              src="../../assets/image/appDownLoad/mob/banner1.png"
              class="videoImg"
            />
            <div class="videobtnT">
              <div class="target_01"
              >
              <a href="https://itunes.apple.com/cn/app/imagine-learning/id638464610?mt=8"><img src="../../assets/image/appDownLoad/mob/macMb.png" class="iphone iphone1"/></a></div>
              <div class="target_02"
              >
              <a href="http://www.4006688991.cn/upload/IL180.apk"><img src="../../assets/image/appDownLoad/mob/andriod_button.png" class="iphone iphone2" @click="weixinDownLoadZheZhao"/></a></div>
              <div class="target_03"
              >
              <a href="https://itunes.apple.com/cn/app/imagine-learning/id638464610?mt=8"><img src="../../assets/image/appDownLoad/mob/ipad_button.png" class="iphone iphone3"/></a></div>
              <div class="target_04"
              >
              <a href="http://www.4006688991.cn/upload/IL.msi"><img src="../../assets/image/appDownLoad/mob/windows_button.png" class="iphone" @click="weixinDownLoadZheZhao"/></a></div>
            </div>
          </div>
          <div><img src="" /></div>
        </swiper-slide> 
        <!-- 第二个轮播图 -->
     <swiper-slide class="videoItem swiperslide">
          <div class="banner2">
            <img
              src="../../assets/image/appDownLoad/mob/banner2.png"
              class="videoImg"
            />
            <div class="videobtn">
              <div class="target_01">
              <a href="https://apps.apple.com/cn/app/id1454087522">
              <img src="../../assets/image/appDownLoad/mob/ios_button.png" class="iphone iphone1" />
              </a>
              </div>
              <div class="target_02">
              <a href="https://s3.cn-north-1.amazonaws.com.cn/imagine-packages/imagineworld.apk">
              <img src="../../assets/image/appDownLoad/mob/andriod_button.png"  @click="weixinDownLoadZheZhao" class="iphone iphone1"/></a>
              </div>
             

            </div>
          </div>
        </swiper-slide> 
        <!-- 第三个轮播图 -->
        <swiper-slide class="videoItem swiperslide">
          <div class="banner2">
            <img
              src="../../assets/image/appDownLoad/mob/欢乐岛mob@2x .png"
              class="videoImg"
            />
            <div class="videobtn">
              <div class="target_01">
              <a href="https://apps.apple.com/cn/app/id1491000896">
              <img src="../../assets/image/appDownLoad/mob/mob欢乐岛iphone@2x.png" class="iphone iphone1" />
              </a>
              </div>
              <div class="target_02">
              <a href="https://imagine-packages.s3.cn-north-1.amazonaws.com.cn/island.apk">
              <img src="../../assets/image/appDownLoad/mob/mob欢乐岛andriod@2x.png"  @click="weixinDownLoadZheZhao" class="iphone iphone1"/></a>
              </div>
             

            </div>
          </div>
        </swiper-slide> 
        <!-- 第四个轮播图 -->
         <swiper-slide class="videoItem swiperslide">
          <div class="banner2">
            <img
              src="../../assets/image/appDownLoad/mob/mbSwiper.jpg"
              class="videoImg"
            />
            <a class="videobtnK" href="http://app.4006688991.cn/download/imagineclassroom.exe">
    
            </a>
          </div>
        </swiper-slide>
        
        
        <div
          class="swiper-pagination"
          slot="pagination"
        ></div>
      </swiper>
    </div>
    <!-- <div class="headImg_fu">
      <p class="p1">客户端下载</p>
      <div class="head-img1">
        <div class="head-img1FU">
          <a href="https://itunes.apple.com/cn/app/imagine-learning/id638464610?mt=8" target="_blank">
              <img src="../../assets/image/appDownLoad/mob/img_ipad@2x.png" class="imgList"/>
          </a>
        </div>
        <div>
          <a href="http://www.4006688991.cn/upload/IL180.apk" target="_blank" @click="weixinDownLoadZheZhao">
            <img src="../../assets/image/appDownLoad/mob/img_android@2x.png" class="imgList"/>
          </a>
        </div>
      </div>
      <div class="head-img2">
        <div class="head-img2-1">
          <a href="https://itunes.apple.com/cn/app/imagine-learning/id930198788?mt=12" target="_blank">
            <img src="../../assets/image/appDownLoad/mob/img_mac@2x.png" class="imgList"/>
          </a>
        </div>
        <div class="head-img2-2">
          <a href="http://www.4006688991.cn/upload/IL.msi" target="_blank" @click="weixinDownLoadZheZhao">
             <img src="../../assets/image/appDownLoad/mob/img_win@2x.png" class="imgList"/>
          </a>
        </div>
      </div>
      <div class="head-font">
        <p>平板电脑、安卓手机用户也可扫码下方二维码</p>
        <p>根据提示下载安装Imagine Learning系统</p>
      </div>
    </div> -->
    <!-- <div  class="saoma"> 
      <div>
        <img src="../../assets/image/appDownLoad/mob/img_saoma@2x.png"/>
        <p>扫码根据提示下载安装</p>
      </div>
    </div> -->
    <div class="zhinanFonthead">
      <div class="zhinanFont">
        <p class="p1">使用指南</p>
        <p class="p2">第一步：客户端下载</p>
        <p>如上提示，下载“imagine learning”安装包。<br />
          客户端下载注意事项： 不同设备、不同的系统版本有些许区别，<br />
          详情请点击查看<a
            class="caozuo"
            href="http://www.imaginelearning.cn/upload/美国想象力英语_操作指南.pdf"
          >下载操作指南</a></p>
      </div>
      <div class="zhuce">
        <p class="p2">第二步：注册试用账号</p>
        <p>点击下方文本框填写信息，注册试用账号。<br />
          手机号码和您填写的密码，即为Imagine Learning的试用账号。</p>
      </div>
      <div class="zhuceimg">
        <div>
          <img
            src="../../assets/image/appDownLoad/mob/img_biaodan_mob@2x.png"
            class="zhuceimg1"
          />
        </div>
      </div>
      <div class="denglu">
        <p class="p2">第三步：登录账号</p>
        <p class="p3">1、打开“Imagine Learning”客户端，<br />
          填写4006688991.com,<br />点击connect进入系统。</p>
        <p class="p4">2、如下图：填写注册时的手机号、密码，点击登录。</p>
        <div>
          <img
            src="../../assets/image/appDownLoad/mob/img_denglu@2x.png"
            class="ILimg"
          />
        </div>
        <p class="p5">3、进入系统，可以开始学习啦！</p>
      </div>
    </div>
    <div class="wenti">
      <p class="p0">注：操作常见问题</p>
      <p class="p1">1、 APP Store如何寻找Imagine Learning学习软件？<br />
        登录appstore，搜索ImagineLearning（注意：需要IOS6以上版本）</p>
      <p class="p2">2、登录页面，等待过程中一直白屏?
        刷新一下页面。</p>
      <p class="p3">3、家长如何看到用户的学习内容<br />
        关注“美国想象力英语”公众号，<br />
        在菜单栏的“用户中心”中选择“学习报告”，绑定账号即可。</p>
    </div>
    <div class="LB-pcF">
      <div class="LB-pc">
        <span
          class="qhbtn juTopF"
          @click="switchBG('left')"
        ><img
            src="../../assets/image/appDownLoad/pc/forward.png"
            alt=""
            class="MimgLeft"
          ></span>
        <div class="lbZBg-pc">
          <img
            :src="LBBGUrl[footLB]"
            alt=""
            class="zbg-img"
          >
        </div>
        <div class="lbNumBtn-pc">
          <img
            :src="LBbtnNumUrl[footLB]"
            alt=""
            class="bottomImgNum"
          >
        </div>
        <span
          class="qhbtn juTopL"
          @click="switchBG()"
        ><img
            src="../../assets/image/appDownLoad/pc/back.png"
            alt=""
            class="MimgRight"
          ></span>
      </div>
    </div>
    <div
      class="zheZhaoBg"
      @touchmove.prevent
      @click="clickWXzheZhao"
      v-if="isWeixin"
    >
      <div class="arrow"></div>
      <div class="tsTest">
        <p>若需要<span>下载</span>此应用，请点击右上角按钮，</p>
        <p>选择「<span>在浏览器中打开</span>」即可下载安装</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      isWeixin: false,
      footLB: 0,
      LBbtnNumUrl: [
        require("../../assets/image/appDownLoad/pc/number_1.png"),
        require("../../assets/image/appDownLoad/pc/number_2.png"),
        require("../../assets/image/appDownLoad/pc/number_3.png"),
        require("../../assets/image/appDownLoad/pc/number_4.png"),
        require("../../assets/image/appDownLoad/pc/number_5.png")
      ],
      LBBGUrl: [
        require("../../assets/image/appDownLoad/mob/1.png"),
        require("../../assets/image/appDownLoad/mob/2.png"),
        require("../../assets/image/appDownLoad/mob/3.png"),
        require("../../assets/image/appDownLoad/mob/4.png"),
        require("../../assets/image/appDownLoad/mob/5.png")
      ],
      SwiperOption: {
        slidesPerView: 1,
        initialSlide: 0,
        centeredSlides: true,
        loop:true,
        autoplay: {
          delay: 4000
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  methods: {
    clickWXzheZhao(e) {
      this.isWeixin = false;
      return;
    },
    switchBG(biaoshi) {
      if (biaoshi === "left") {
        if (this.footLB === 0) {
          this.footLB = 4;
        } else {
          this.footLB--;
        }
      } else {
        if (this.footLB === 4) {
          this.footLB = 0;
        } else {
          this.footLB++;
        }
      }
    },
    weixinDownLoadZheZhao(e) {
      var is_weixin = (function() {
        return (
          navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
        );
      })();
      if (is_weixin) {
        this.isWeixin = true;
        if (e && e.preventDefault) {
          e.preventDefault();
        } else {
          window.event.returnValue = false;
        }
      }
      return;
    }
  }
};
</script>

<style scoped lang="scss">
@import '~style/mixin.scss';
.swiper-container {
  position: relative;
  .banner1 {
    .videoImg{
      width:100%;
    }
  }
  .videobtnK{
     position: absolute;
      top: vm(240);
      left: vm(456);
      width: vm(164);
      height: vm(50);
      background-color: red;
      opacity: 0;
      a{
        width: 100%;
        height: 100%;
      }
  }
  .videobtnT{
    width: 100%;
    display: flex;
    position: absolute;
    top: vm(333);
    padding-left: vm(39);
    .target_01{
      margin-right: vm(33);
    }
    .target_02{
      margin-right: vm(33);
    }
    .target_03{
       margin-right: vm(33);
    }
    .iphone{
    height: vm(52);
    width: vm(143);
    margin-right: vp(12);
    }
  }
  .banner2 {
    position: relative;
    .videobtn{
      display: flex;
      justify-content: space-around;
      position: absolute;
      top: vm(245);
      left: vm(336);
      width: vm(414);
       .target_01{
      margin-right: vm(11);
    }
    .target_02{
      margin-right: vm(11);
    }
    .target_03{
       margin-right: vm(11);
    }
      a{
        text-decoration: none;
  
        line-height: 12px;;
      }
     .ipadText{
       position: absolute;
       width:vm(200);
       height:vm(17);
       font-size:6px;
       font-family:PingFangSC-Medium,PingFang SC;
      //  font-weight:500;
       color:rgba(169,218,253,1);
       line-height:vm(32);
      //  text-decoration: none;
       transform: scale(0.5);
      left: vm(240);
       
     }
     .ipad{
       opacity: 0.5;
     }
    }
    .videoImg{
      width:100%;
    }
  }
    .iphone{
    height: vm(41);
    width: vm(118);
    }
    
}
.zheZhaoBg {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 100000000;
}
.arrow {
  position: absolute;
  right: 6.4vw;
  top: 0vw;
  width: 17.33vw;
  height: 35.466vw;
  background-image: url("../../assets/image/appDownLoad/mob/arrow_img@2x.png");
  background-size: 100% 100%;
}
.tsTest {
  padding-left: 19.5vw;
  text-align: left;
  margin-top: 36.8vw;
  font-family: SHS-R;
  font-size: 3.733vw;
  color: rgb(255, 255, 255);
}
.tsTest span {
  font-weight: bold;
  color: rgb(252, 243, 3);
}
.tsTest > p {
  line-height: 5.333vw;
}
.zbg-img {
  width: vm(410);
  height: vm(730);
}
.lbNumBtn-pc {
  margin-top: vm(27);
}
.headimg {
  width: 100vw;
  height: 47vw;
}
.headImg_fu {
  text-align: center;
  padding-top: 8vw;
  padding-left: 4vw;
  padding-right: 4vw;
  .p1 {
    text-align: center;
    font-family: "SHS-B";
    font-size: 5vw;
    color: #e2211c;
  }
  .imgList {
    width: 24vw;
  }
  .head-img1 {
    margin-top: 7vw;
    display: flex;
    .head-img1FU {
      margin-right: 11vw;
      margin-left: 18vw;
    }
  }
  .head-img2 {
    display: flex;
    .head-img2-1 {
      margin-right: 12vw;
    }
  }
  .head-font {
    font-size: 3vw;
    font-family: "SHS-R";
  }
}
.saoma {
  text-align: center;
  margin-top: 5vw;
}
.zhinanFonthead {
  margin-top: 5vw;
}
.zhinanFont {
  text-align: center;
  font-size: 3vw;
  font-family: "SHS-R";
  .p1 {
    font-size: 5vw;
    color: #e1251b;
  }
  .p1 {
    font-size: 5vw;
  }
  .caozuo {
    color: #e1251b;
  }
}
.LB-pcF {
  margin-top: vm(34);
  text-align: center;
  position: relative;
  .MimgLeft {
    position: absolute;
    top: 41vw;
    left: vm(60);
    width: vm(61);
    height: vm(61);
  }
  .MimgRight {
    position: absolute;
    top: 41vw;
    right: vm(60);
    width: vm(61);
    height: vm(61);
  }
  margin-bottom: vm(89);
  .LB-pc {
    .lbNumBtn-pc {
      .bottomImgNum {
        width: vm(43);
        height: vm(43);
      }
    }
  }
}
.zhuce {
  text-align: center;
  font-size: 3vw;
  font-family: "SHS-R";
  line-height: 4vw;
  margin-top: 4vw;
  margin-bottom: 5vw;
  .p1 {
    font-size: 5vw;
  }
  .p1 {
    font-size: 5vw;
  }
  .caozuo {
    color: #e1251b;
  }
}
.zhuceimg {
  text-align: center;
}
.zhuceimg1 {
  width: 69vw;
  height: 94vw;
}
.denglu {
  text-align: center;
  .p2 {
    font-size: 4vw;
    font-family: "SHS-R";
  }
  .p3 {
    font-family: "SHS-R";
    font-size: 3vw;
  }
  .p4 {
    font-family: "SHS-R";
    font-size: 3vw;
    margin-top: 4vw;
    margin-bottom: 3vw;
  }
  .p5 {
    font-family: "SHS-R";
    font-size: 3vw;
    margin-top: 3vw;
  }
}
.ILimg {
  width: 77vw;
  height: 58vw;
}
.wenti {
  text-align: center;
  .p0 {
    margin-bottom: 5vw;
    margin-top: 5vw;
    color: #e1251b;
    font-size: 4vw;
    font-family: "SHS-B";
  }
  .p1 {
    font-family: "SHS-R";
    margin-top: 5vw;
    font-size: vm(20);
  }
  .p2 {
    font-family: "SHS-R";
    margin-top: 5vw;
    font-size: vm(20);
  }
  .p3 {
    font-family: "SHS-R";
    margin-top: 5vw;
    font-size: vm(20);
  }
 
}
</style>


// WEBPACK FOOTER //
// src/pages/appDownLoad/mobAppDownLoad.vue